export const formatPhoneNumber = (number: string) => {
  const matches = number.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (matches) {
    return `${matches[1]} ${matches[2]} ${matches[3]}`;
  } else {
    return number;
  }
};
